import {useEffect, useRef, useState} from "react";
import {newStateId} from "../unreal/VideoController";


function hasDepsChanged(oldDeps:any[], deps:any[]) {
    if (oldDeps.length != deps.length)
    {
        return true;
    }
    for (let i = 0; i < oldDeps.length; ++i) {
        if (oldDeps[i] !== deps[i]) return true;
    }
    return false;

}

export function useStateId(deps:any[]) {

    const stateRef = useRef<string>(newStateId());
    const oldDeps = useRef<any[]|null>(null);

    const oldDepsToUse = oldDeps.current === null ? deps : oldDeps.current;
    if (hasDepsChanged(oldDepsToUse, deps)) {
        stateRef.current = newStateId();
        oldDeps.current = deps;
        console.log("State id changed");
    }
    if (oldDeps.current === null) {
        oldDeps.current = deps;
    }
    return stateRef.current;
}